import styled from 'styled-components'

export const WhatsAppFloat = styled.a`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 68px;
  height: 68px;
  background: rgb(255, 255, 255);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 9999;
  transition: transform 0.3s ease, bottom 0.3s ease;

  img {
    width: 46px;
  }

  &:hover {
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    width: 54px;
    height: 54px;
    right: 16px;
    /* sobe quando a barra fixa de compra está visível */
    bottom: ${({ $raised }) => ($raised ? '92px' : '16px')};

    img {
      width: 36px;
    }
  }
`
